var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-full bg-white p-[10px] h-full"},[(_vm.section === 'invoice_occasion')?_c('div',[_c('invoice-occassion',{key:_vm.section})],1):_vm._e(),(_vm.section === 'payments')?_c('div',[_c('paid-git-invoice',{key:_vm.section})],1):_vm._e(),(_vm.section === 'credits')?_c('div',[_c('credited-git-invoice',{key:_vm.section})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }